<template lang="pug">
  section.hero.is-black-ducter(ref="sust" :style="{ backgroundImage: 'url(' + require('@/assets/ducter_small.svg') + ')', repeat: 'repeat' }")
    .container
      .columns.has-text-centered.content.is-vcentered
        .column.is-6
          h2.has-text-white.title.is-size-3 Sustentabilidad
          p.has-text-white.is-size-4 Nuestra empresa está comprometida con las buenas prácticas, mejora continua y sobre todo en pro del medio ambiente, siendo la sustentabilidad un punto muy importante en nuestra visión como empresa.
        .column.is-6
          figure.image.is-600x600
            img(:src="require('@/assets/f6.jpg')")
</template>

<script>
  export default {
    name: 'Sustentabilidad',
    props: {
      seccionSel: {
        type: String,
        default: ''
      },
    },
    watch: {
      seccionSel() {
        if (this.seccionSel === 'sust') {
          this.$refs['sust'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .hero {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .content {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .is-600x600 {
    max-height: 450px;
    max-width: 450px;
  }

  .is-black-ducter {
    background-color: #000000;
  }
</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/Sustentabilidad.vue